import React, { Fragment } from 'react';
import CardInfoField from './card-info-field';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
export function Prescription(prescriptionValue, currentPosition, prescriptionPosition) {
    const showPrescription = prescriptionPosition === currentPosition;
    return (React.createElement(Fragment, null, showPrescription && prescriptionValue != null && (CardInfoField(MessageService.translate('label.infusion-viewer.prescription'), String(prescriptionValue), ''))));
}
//# sourceMappingURL=prescription.js.map